import './AddOfferInfo.css';
import '../SingleOffer/SingleOffer.css'
import { useHistory } from 'react-router-dom';
import { Helmet } from "react-helmet";
import OfferTypes from '../../data/OfferTypes';
import { BiWrench } from 'react-icons/bi';
import { GiAncientScrew } from 'react-icons/gi';
import { GiStoneWheel } from 'react-icons/gi';
import { GiBlacksmith } from 'react-icons/gi';
import { useAtom } from 'jotai';
import { useShowPopUpModal, useModalVersion, useModalInfo } from '../../data/GlobalStates';


const AddOfferInfo = () => {

  const history = useHistory();
  //stany globalne:
  const [ ShowPopUpModal, setShowPopUpModal] = useAtom(useShowPopUpModal);
  const [ ModalVersion, setModalVersion] = useAtom(useModalVersion);
  const [ ModalInfo, setModalInfo] = useAtom(useModalInfo);

  const backToMain = () => {
    history.push('/')
  };

  const moveToRegister = () => {
      history.push('/login')
      setShowPopUpModal(true)
      setModalVersion(2)
      setModalInfo({title:'Nie jesteś zalogowany', message:'Aby dodać ofertę zaloguj się lub załóż konto'})
  };

    return (
        <div id='AddOfferInfoMainDiv'> 
       <Helmet>
          <title>SteelJobs.pl</title>
          <meta name="robots" content="index, nofollow" />
          <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/chat-app-9fa6b.appspot.com/o/SiteLogos%2FMiniLogo.png?alt=media&token=94564b1d-4339-4a63-86a5-1410ea8adf73"/>
          <meta name="description" content="praca spawacz, praca monter, stoczniowcy, spawalnictwo" />
        </Helmet>
          <h1 id='Logo' onClick={backToMain}>SteelJobs.pl</h1>
            <h2 className='AddOfferInfoText'>Dzięki nam dotrzesz do pracowników branży metalurgicznej</h2>
            <h2 className='AddOfferInfoText'>Oraz dostaniesz natychmiastowe powiadomienie gdy pracownik będzie szukał pracy</h2>
               <h2 className='AddOfferInfoText'>Dostępne rodzaje pojedyńczych ogłoszeń w dziale ofert pracy:</h2>
               <div id='Samples'>
                 <div className='SampleContainer' onClick={moveToRegister}>
                   <div className='AddOfferInfoHeaderContainer'>
                     <h2 className='DisplayTypeHeader'>Ogłoszenie Podstawowe</h2>
                   </div>
                   <div className='OfferTypeInfo'>
                    <p>- Dwie aktywne oferty bez opłat</p>
                    <p>- Czas wyświetlania <strong>{OfferTypes[0].displayTime}</strong> dni</p>
                    <p>- Wyświetlanie po ofertach premium</p>
                   </div>
                   <div className='IconsContainer'>
                     <BiWrench className='AddOfferIcons'/>
                       <GiAncientScrew className='AddOfferIcons' id='animatedScrew'/>
                       <GiStoneWheel className='AddOfferIcons'/>
                     <GiBlacksmith className='AddOfferIcons'/>
                   </div> 
                 </div>
            <div className='SampleContainerPremium' onClick={moveToRegister}>
               <div className='AddOfferInfoHeaderContainer'>
                 <h2 className='DisplayTypeHeader'>Ogłoszenie Premium</h2>
               </div>
               <div className='OfferTypeInfo'>
                <p>- Wyświetlanie przed ofertami podstawowymi</p>
                <p>- Wyróżnienie na liście oraz mapie ofert</p>
                <p>- Czas wyświetlania 30 dni</p>
                <p>- Możliwość zakupu jedynie w pakietach</p>
                <p>- Cena jednostkowa zależna jest od wybranego pakietu</p>  
               </div>
               <div className='IconsContainer'>
                   <BiWrench className='AddOfferIcons'/>
                   <GiAncientScrew className='AddOfferIcons'/>
                   <GiStoneWheel className='AddOfferIcons' id='animatedWheel'/>
                   <GiBlacksmith className='AddOfferIcons'/>
               </div>
          </div>
         </div>
         <div id='Samples'>
           <h3>Pakiety ogłoszeń:</h3>
           
           <p className='AddOfferInfoText'>Oferty podstawowe.</p>

                  <div className='SampleContainer' onClick={moveToRegister}>
             <div className='AddOfferInfoHeaderContainer'>
                <h2 className='DisplayTypeHeader'>Pakiet ofert podstawowych</h2>
             </div>
               <div className='OfferTypeInfo'>
                  <p>- <strong>50</strong> PLN + 23% Vat</p>
                  <p>- Brak limitu ilości dodanych ofert</p>
                  <p>- Ważny 30 dni od daty zakupu</p>
               </div>
               <div className='IconsContainer'>
                   <BiWrench className='AddOfferIcons'/>
                   <GiAncientScrew className='AddOfferIcons'/>
                   <GiStoneWheel className='AddOfferIcons'/>
                   <GiBlacksmith className='AddOfferIcons'/>
               </div>
          </div>

           <p className='AddOfferInfoText'>Oferty premium.</p>
    
          <div className='SampleContainer' onClick={moveToRegister}>
             <div className='AddOfferInfoHeaderContainer'>
                <h2 className='DisplayTypeHeader'>Pakiet 30 ofert premium</h2>
             </div>
               <div className='OfferTypeInfo'>
                  <p>- <strong>{OfferTypes[4].price}</strong> PLN + 23% Vat</p>
                  <p>- cena jednostkowa <strong>{(OfferTypes[4].price/30).toFixed(2)}</strong> PLN + 23% Vat</p>
               </div>
               <div className='IconsContainer'>
                   <BiWrench className='AddOfferIcons'/>
                   <GiAncientScrew className='AddOfferIcons'/>
                   <GiStoneWheel className='AddOfferIcons'/>
                   <GiBlacksmith className='AddOfferIcons'/>
               </div>
          </div>
          <div className='SampleContainer' onClick={moveToRegister}>
             <div className='AddOfferInfoHeaderContainer'>
                <h2 className='DisplayTypeHeader'>Pakiet 50 ofert premium</h2>
             </div>
               <div className='OfferTypeInfo'>
                  <p>- <strong>{OfferTypes[5].price}</strong> PLN + 23% Vat</p>
                  <p>- cena jednostkowa <strong>{(OfferTypes[5].price/50).toFixed(2)}</strong> PLN + 23% Vat</p>
               </div>
               <div className='IconsContainer'>
                   <BiWrench className='AddOfferIcons'/>
                   <GiAncientScrew className='AddOfferIcons'/>
                   <GiStoneWheel className='AddOfferIcons'/>
                   <GiBlacksmith className='AddOfferIcons'/>
               </div>
          </div>
         </div>
         <div id='RegisterInfo'>
            <h1 className='AddOfferInfoText'>Akceptowane formy płatności:</h1> 
             <p>- BLIK</p>
             <p>- Karta Płatnicza</p>
             <p>- Przelewy 24</p>
             <p>- Link</p>
             <p>- Google Pay</p>
            <h1 className='AddOfferInfoText'>Chcesz dodać ogłoszenie ? </h1>
            <button id='RegisterBtn'  onClick={() => {history.push('/login')}}>Rejestracja</button>
          </div>
         <div id='AddOfferInfoContactDiv'>
               <h1 className='AddOfferInfoText'>Masz pytania ?</h1>
               <h2 className='AddOfferInfoText'>Skontaktuj się z nami:</h2>
               <div id='ContactDoubleDiv'>
                   <div className='InfoBox'>
                    <p>mail: steeljobs@steeljobs.pl</p>
                   </div>
               </div>
           </div>
        </div>
    )
}

export default AddOfferInfo;
